import {
  Checkbox,
  Disclosure as RacDisclosure,
  DisclosurePanel,
} from 'react-aria-components';
import styled from 'styled-components';

export const Disclosure = styled(RacDisclosure)`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  max-width: 422px;
  background: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-base);

  &:has([data-focus-visible]) {
    box-shadow: var(--shadow-focus);
  }

  &[data-expanded] {
    background: var(--grey-100);
    border-color: var(--brand-900);
    border-bottom-width: 1px;
  }
`;

export const Field = styled(Checkbox)`
  display: flex;
  align-items: center;
  gap: var(--spacing-base);
  padding: var(--spacing-large);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-size-text-md);
  color: var(--text-color);
`;

export const Label = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-small);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  line-height: 1.5rem;
  color: var(--black);

  & span {
    color: var(--grey-500);
  }
`;

export const CheckBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-base);
  transition: all 200ms;

  &:is([data-pressed] &) {
    border-color: var(--brand-900);
  }

  &:is([data-focus-visible] &) {
    box-shadow: 0 0 0 2px var(--brand-100), 0 0 0 4px var(--brand-900);
    outline: 0;
  }

  &:is([data-expanded] &) {
    border-color: var(--brand-900);
    background: var(--brand-900);
  }

  & svg {
    fill: none;
    transition: all 200ms;

    & path {
      stroke: var(--white);
    }
  }
`;

export const Icon = styled.div`
  display: flex;
  width: 20px;
`;

export const Panel = styled(DisclosurePanel)`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
  padding: var(--spacing-base);
  background: var(--grey-50);
  border-top: 1px solid var(--grey-300);
  border-radius: 0 0 var(--radius-base) var(--radius-base);

  &[hidden="until-found"] {
    padding: 0;
    border: 0;
  }
`;
